var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCubesfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m391 250-120 40 120 40 120-40z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 290 120 40 120-40-120-40z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.743.77c-3.079-1.026-6.408-1.026-9.487 0l-115.256 38.419 120 40 120-40z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 512 105-35 v-155.377l-105 35z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 466.189c0 6.457 4.131 12.189 10.257 14.23l94.743 31.581v-155.377l-105-35z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 477 105 35 v-155.377l-105-35z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 512 94.743-31.581c6.125-2.042 10.257-7.774 10.257-14.23v-144.566l-105 35z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 229 105 35 v-158.188l-105-35.001z",
    fill: "#52771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 229v-158.189l-105 35.001 v158.188z",
    fill: "#52771A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubesfill);
export default __webpack_public_path__ + "static/media/cubesfill.a887501d304d6b476182ebe2b06c34d7.svg";
export { ForwardRef as ReactComponent };